import clsx from "clsx"

import { Skeleton } from "@particles/index"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import styles from "./JobPreviewDetails.module.scss"
import { JobPreviewDetailsProps } from "./JobPreviewDetails.types"

export default function JobPreviewDetails(props: JobPreviewDetailsProps) {
    const { details } = props
    const { isLoading } = useJobPreviewCard()

    if (isLoading && !details) {
        return (
            <div className={styles.reasonsForCallWrapper}>
                <Skeleton width={100} height={16} />
                <Skeleton width={200} height={16} />
            </div>
        )
    }

    return (
        <div className={styles.reasonsForCallWrapper}>
            <p className={styles.reasonsForCallLabel}>Reason For Call</p>
            <p
                className={clsx(styles.reasonsForCallValue, {
                    [styles.noReasonForCall]: !details,
                })}
            >
                {details ? details : "Not mentioned"}
            </p>
        </div>
    )
}
